/*
*   Actions which are passed from accreditation.reducer.js to improvement.reducer.js
 */

export const PREFIX = 'ACCREDITATION_IMPROVEMENT';

export const TYPES = {
    FETCH_SITE_LOCATION_DETAILS:    `${PREFIX}_FETCH_SITE_LOCATION_DETAILS`,
    SET_ACTION_DETAILS:             `${PREFIX}_SET_ACTION_DETAILS`,
    RESET_NEW_STEP_DETAILS:         `${PREFIX}_RESET_NEW_STEP_DETAILS`,
    RESET_REQUIREMENT:              `${PREFIX}_RESET_REQUIREMENT`,
    SELECT_STEP:                    `${PREFIX}_SET_STEP_DIALOG`,
    UPDATE_STEP:                    `${PREFIX}_UPDATE_STEP`,
    FETCH_REQUIREMENT_EVIDENCE_GROUPS: `${PREFIX}_FETCH_REQUIREMENT_EVIDENCE_GROUPS`,
    // INIT_REVIEW_STATUSES:           `${PREFIX}_INIT_REVIEW_STATUSES`,
    SELECT_NEW_STEP_REQUIREMENT:    `${PREFIX}_SELECT_NEW_STEP_REQUIREMENT`,
    SET_IMPROVEMENT_ACTION_DETAILS: `${PREFIX}_SET_IMPROVEMENT_ACTION_DETAILS`,
    SET_IMPROVEMENT_STEP_DETAILS:   `${PREFIX}_SET_IMPROVEMENT_STEP_DETAILS`,
    UPDATE_IMPROVEMENT_STEP:        `${PREFIX}_UPDATE_IMPROVEMENT_STEP`,
    RESET_SELECTED_EVIDENCE_GROUP:  `${PREFIX}_RESET_SELECTED_EVIDENCE_GROUP`,
    RESET_LINKABLE_EVIDENCE_GROUPS: `${PREFIX}_RESET_LINKABLE_EVIDENCE_GROUPS`,
};
